// Common language configuration in Chinese

export default {
  ARRIVED: 'Arrived'
};
